import React from "react";
import "./App.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Navbar from "./components/layout/Navbar";
import Home from "./components/core/Home";
import Signup from "./components/core/Signup";
import Signin from "./components/core/Signin";
import AdminRoute from "../src/components/auth/adminroutes";
import Addroom from "./components/core/admin/Addroom";
import Addcategory from "./components/core/admin/Addcategory";
import ListRooms from "./components/core/admin/ListRooms";
import SingleRoom from "./components/core/admin/SingleRoom";
import Room from "./components/core/room/Room";
import EditRoom from "./components/core/admin/EditRoom";
import Profile from "./components/core/normaluser/Profile";
import City from "./components/core/city/City";
import AddCity from "./components/core/admin/AddCity";
import Book from "./components/core/book/Book";
import Pagenotfound from "./Pagenotfound";
import Mybooking from "./components/core/normaluser/Mybooking";
import Order from "./components/core/admin/order/Order";

// Private Route for login user
import PrivateRoute from "../src/components/auth/PrivateRoute";

// AdminDashboard Route
import AdminDashboard from "./components/core/admin/AdminDashboard";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Switch>
        <Route exact path="/" component={City} />
        <Route exact path="/home/:homeId" component={Home} />
        <Route exact path="/signup" component={Signup} />
        <Route exact path="/signin" component={Signin} />
        <Route exact path="/room/:roomId" component={Room} />
        <PrivateRoute exact path="/user/dashboard" component={Profile} />
        <PrivateRoute exact path="/book/:bookid" component={Book} />
        <PrivateRoute exact path="/mybooking/:bookid" component={Mybooking} />
        <AdminRoute exact path="/admin/dashboard" component={AdminDashboard} />
        <AdminRoute exact path="/create/room" component={Addroom} />
        <AdminRoute exact path="/create/category" component={Addcategory} />
        <AdminRoute exact path="/list/rooms" component={ListRooms} />
        <AdminRoute
          exact
          path="/listrooms/room/:ListRooms"
          component={SingleRoom}
        />
        <AdminRoute
          exact
          path="/listrooms/room/edit/:SingleRoom"
          component={EditRoom}
        />
        <AdminRoute exact path="/create/city" component={AddCity} />
        <AdminRoute exact path="/lists/room/orders" component={Order} />
        <Route component={Pagenotfound} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
